export const LOADER_STATUS = 'gstr2a/LOADER_STATUS';
export const SET_TABLE_DATA = 'gstr2a/SET_TABLE_DATA';